"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { getDefaultQueryRetry } from "@/components/react-query-wrapper/utils/query-utils";
import { fetchOfficialWaves } from "@/services/api/waves-v2-api";
interface UseOfficialWavesProps {
  readonly viewerIdentityKey?: string | null | undefined;
  readonly refetchInterval?: number | undefined;
  readonly refetchIntervalInBackground?: boolean | undefined;
}
interface OfficialWavesQueryKeyParams {
  readonly viewer_identity?: string | undefined;
}
function getOfficialWavesQueryKeyParams(viewerIdentityKey: string | null | undefined): OfficialWavesQueryKeyParams {
  const normalizedViewerIdentityKey = viewerIdentityKey?.trim().toLowerCase() ?? null;
  return normalizedViewerIdentityKey ? {
    viewer_identity: normalizedViewerIdentityKey
  } : {};
}
export function useOfficialWaves(t0) {
  const $ = _c(22);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    viewerIdentityKey,
    refetchInterval: t2,
    refetchIntervalInBackground: t3
  } = t1;
  const refetchInterval = t2 === undefined ? Infinity : t2;
  const refetchIntervalInBackground = t3 === undefined ? false : t3;
  let t4;
  if ($[2] !== viewerIdentityKey) {
    t4 = getOfficialWavesQueryKeyParams(viewerIdentityKey);
    $[2] = viewerIdentityKey;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const queryKeyParams = t4;
  const [lastErrorTimestamp, setLastErrorTimestamp] = useState(null);
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setLastErrorTimestamp(Date.now());
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleRetryFailure = t5;
  let t6;
  if ($[5] !== queryKeyParams) {
    t6 = [QueryKey.OFFICIAL_WAVES, queryKeyParams];
    $[5] = queryKeyParams;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = getDefaultQueryRetry(handleRetryFailure);
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== refetchInterval || $[9] !== refetchIntervalInBackground || $[10] !== t6) {
    t8 = {
      queryKey: t6,
      queryFn: fetchOfficialWaves,
      refetchInterval,
      refetchIntervalInBackground,
      ...t7
    };
    $[8] = refetchInterval;
    $[9] = refetchIntervalInBackground;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const query = useQuery(t8);
  let t9;
  if ($[12] !== query.data) {
    t9 = query.data ?? [];
    $[12] = query.data;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const waves = t9;
  let t10;
  if ($[14] !== lastErrorTimestamp || $[15] !== query) {
    t10 = () => {
      if (lastErrorTimestamp !== null && Date.now() - lastErrorTimestamp < 30000) {
        setTimeout(() => {
          query.refetch().catch(_temp);
        }, 30000);
        return;
      }
      query.refetch().catch(_temp2);
    };
    $[14] = lastErrorTimestamp;
    $[15] = query;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const refetch = t10;
  let t11;
  if ($[17] !== query.isFetching || $[18] !== query.status || $[19] !== refetch || $[20] !== waves) {
    t11 = {
      waves,
      isFetching: query.isFetching,
      status: query.status,
      refetch
    };
    $[17] = query.isFetching;
    $[18] = query.status;
    $[19] = refetch;
    $[20] = waves;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}
function _temp2() {}
function _temp() {}